<template>
  <div>
    <h1 class="title">{{ title }}</h1>
    <v-tabs 
        class="btr project-edit-tabs"
        v-model="tab"
        background-color="black"
        dark
        slider-color="orange"
    >
      <v-tab>
        Dashboard
      </v-tab>
      <v-tab>
        Projeto
      </v-tab>
      <v-tab>
        Cliente
      </v-tab>
      <v-tab>
        Endereço
      </v-tab>
      <v-tab>
        Datalogger
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="pa-4" touchless>
      <v-tab-item>
        <ProjectDashboard :project_id="project_id" :project_tax="power_tax" v-if="project_id" />
      </v-tab-item>
      <v-tab-item>
        <Project :project_id="project_id" />
      </v-tab-item>
      <v-tab-item>
        <Company
            :endpoint_load="'/admin/project/company.get?id=' + this.project_id"
            endpoint_edit="/admin/project/company.edit"
            :payload="{ project_id: this.project_id }"
        />
      </v-tab-item>
      <v-tab-item>
        <Address
            :endpoint_load="'/admin/project/address.get?id=' + this.project_id"
            endpoint_edit="/admin/project/address.edit"
            :payload="{ project_id: this.project_id }"
        />
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col class="col-12 text-right">
            <v-btn depressed small dark color="success" v-if="!disabled" @click="disabled = !disabled" class="ma-0">ativo</v-btn>
            <v-btn depressed small dark color="red darken-2" v-if="disabled" @click="disabled = !disabled" class="ma-0">inativo</v-btn>
          </v-col>
          <v-col class="col-12">
            <v-select class="bgalpha"
                :items="driversSelect"
                v-model="driver_id"
                label="Driver"
                hide-details
            ></v-select>
          </v-col>
          <v-col class="col-12">
            <v-text-field
                filled
                dense
                label="URL (endereço web)"
                autocomplete="url"
                name="url"
                v-model="url"
                :error-messages="errors.url"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
          <v-col class="col-12 col-sm-6">
            <v-text-field
                filled
                dense
                label="Login"
                autocomplete="login"
                name="login"
                v-model="login"
                :error-messages="errors.login"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
          <v-col class="col-12 col-sm-6">
            <v-text-field
                filled
                dense
                label="Senha"
                autocomplete="password"
                name="password"
                v-model="password"
                :error-messages="errors.password"
                prepend-inner-icon="mdi-format-text"
                hide-details="auto"
                placeholder=" "
                type="text"
            ></v-text-field>
          </v-col>
        </v-row>
        <div
            class="mt-5 pa-2 bgalpha text-right"
        >
          <v-btn
              color="primary"
              @click="testConnection()"
              class="mr-2"
          >
            Testar Conexão
          </v-btn>
          <v-btn
              color="success"
              @click="dataloggerUpdate()"
              :loading="$store.state.loading"
          >
            Salvar
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ProjectDashboard from "@/components/ProjectDashboard";
import Project from "@/components/Project";
import Company from "@/components/Company";
import Address from "@/components/Address";

export default {
  components: {
    Address,
    Company,
    Project,
    ProjectDashboard
  },
  data() {
    return {
      project_id: parseInt(this.$router.currentRoute.params.project_id),
      errors: [],
      // project
      tab: 0,
      id: 0,
      title: '',
      power_tax: 0,
      // inverter
      editInverterState: false,
      drivers: [],
      driver_id: 0,
      datalogger_id: 0,
      url: '',
      login: '',
      password: '',
      disabled: false
    }
  },
  mounted() {
    this.projectInfo();
    this.driverList();
    this.dataloggerInfo();
  },
  watch: {
    driver_id(id) {
      const driver = this.drivers.find(d => d.id == id);
      if (driver) {
        this.url = driver.url; 
      }
    }
  },
  methods: {
    testConnection() {
      this.$api
          .post('/admin/project/project.testConnection', {
            id: this.project_id
          })
          .then(response => {
            if (response.data.test == true) {
              this.$root.$emit('GlobalSnackbar', {type: 'success', message: 'A conexão está ativa'});
            } else {
              this.$root.$emit('GlobalSnackbar', {type: 'error', message: 'A conexão não está ativa'});
            }
          });
    },
    projectInfo() {

      const payload = {
        id: this.project_id
      }

      this.$api
          .post('/admin/project/project.info', payload)
          .then(response => {
            this.id = response.data.id;
            this.power_tax = response.data.power_tax;
            this.title = response.data.title;
          });
    },
    driverList() {
      this.$api
          .post('/admin/driver/driver.list')
          .then(response => {
            if (Array.isArray(response.data)) {
              this.drivers = response.data;
            }
          });
    },
    dataloggerInfo() {
      const payload = {
        project_id: this.project_id
      };

      this.$api
          .post('/admin/project/datalogger.info', payload)
          .then(response => {
            this.datalogger_id = response.data.id;
            this.disabled = response.data.disabled;
            this.driver_id = response.data.driver_id;
            this.url = response.data.url;
            this.login = response.data.login;
            this.password = response.data.password;
          });
    },
    dataloggerUpdate() {
      const payload = {
        id: this.datalogger_id,
        project_id: this.project_id,
        driver_id: this.driver_id,
        url: this.url,
        login: this.login,
        password: this.password,
        disabled: this.disabled
      }

      this.$api
          .post('/admin/project/datalogger.update', payload)
          .then(response => {
            if (response.data.id) {
              this.id = response.data.id;
              this.$root.$emit('GlobalSnackbar', { type: 'success', message: 'Datalogger salvo' });
              //this.dashboardLoad();
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
    }
  },
  computed: {
    driversSelect() {
      return this.drivers.map((item) => {
        return {
          'text': item.title,
          'value': item.id
        }
      })
    }
  },
}
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
  .project-edit-tabs {
    .v-slide-group__prev--disabled {
      display: none !important;
    }
  }
}
</style>